import React from 'react';
import { useStore } from '../../stores';

import { ButtonFavorite } from './ButtonFavorite';
import { ButtonNavigate } from './ButtonNavigate';
import { ButtonParking } from './ButtonParking';

export const Options = ({  }) => {

const { config } = useStore();
    
  return (

    <div className="my-6 flex flex-1 justify-between">
        
      <ButtonNavigate />

      <ButtonFavorite />

      {config.features.parking ? (
        <ButtonParking />
      ) : null}
      
    </div>

  );
  
};